<template>
  <div class="que-bar">
    <div class="que-id">{{id}}</div>
    <div class="que-name-info clearfix">
      <div class="que-name clearfix">
        <img :src="fimgScr">
        <span>{{queInfo.que_name}}</span>
      </div>
      <div class="que-tags">
        <span v-for="item in fque_tags" :key="item" @click="tagClick">{{item}}</span>
      </div>
    </div>
    <div class="use-num">
      <span>{{queInfo.use_num}}</span>
    </div>
    <div class="que-difficulty">
      <span :class="fdifficultyCls">{{fdifficulty}}</span>
    </div>
    <div class="pass_rate">{{fpass_rate}}</div>
    <div class="students_count">{{queInfo.students_count}}</div>
    <div class="que-button">
      <span @click="routesTopic">开始挑战</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "queBar",
  props:{
    id: Number,
    queInfo:{
      type: Object,
      default: ()=>{
        return{
          gid: '',
          use_num: 0,
          que_name: '',
          que_tags: '',
          difficulty: 0,
          students_count: 0,
          pass_rate: 0,
          contain_answer: ''
        }
      }
    }
  },
  computed:{
    fimgScr: function (){
      if(this.queInfo.contain_answer.toUpperCase() == 'TRUE'){
        return './static/image/icon-pass.png'
      }else{
        return './static/image/icon-no-pass.png'
      }
    },
    fque_tags: function (){
      let tags = this.queInfo.que_tags.split(',')
      return tags
    },
    fdifficulty:function (){
      if(this.queInfo.difficulty == 0){
        return '入门'
      }else if(this.queInfo.difficulty == 10){
        return '简单'
      }else if(this.queInfo.difficulty == 20){
        return '中等'
      }else if(this.queInfo.difficulty == 30){
        return '困难'
      }else {
        return '未定'
      }
    },
    fdifficultyCls: function (){
      if(this.queInfo.difficulty == 0) {
        return 'que_white'
      }else if(this.queInfo.difficulty == 10){
        return 'que_green'
      }else if(this.queInfo.difficulty == 20){
        return 'que_yellow'
      }else if(this.queInfo.difficulty == 30){
        return 'que_red'
      }else {
        return ''
      }
    },
    fpass_rate: function (){
      return Math.trunc(this.queInfo.pass_rate * 100) + '%'
    }

  },
  methods:{
    tagClick: function (e){
      let tags = e.target.innerHTML;
      this.$emit('event-search', tags);
    },
    routesTopic: function (){
      this.$router.push({
          name:'topicView',
          query:{
            gid: this.queInfo.gid
          }
      });
    }
  }
}
</script>

<style scoped>
.que-bar{
  height: 60px;
  box-sizing: border-box;
  background-color: #fff;
  white-space:nowrap;
  overflow: hidden;
}
.que-bar:hover{
  background-color: #eeeeee;
}
.que-id{
  width: 8%;
  max-width: 80px;
  display: inline-block;
  text-align: center;
  font-size: 16px;
  line-height: 50px;
  height: 50px;
}
.que-name-info{
  width: 32%;
  max-width: 400px;
  display: inline-block;
}

.que-name{
  padding-top: 5px;
  padding-bottom: 5px;
}
.que-name img{
  width: 25px;
  height: 25px;
  float: left;
}
.que-name span{
  margin-left: 20px;
  font-size: 18px;
  font-weight: bold;
  float: left;
}
.use-num{
  width: 10%;
  max-width: 100px;
  display: inline-block;
}
.que-tags{
  margin-left: 20px;
}
.que-tags span{
  font-size: 12px;
  margin-left: 20px;
  border: 1px solid #eee;
  border-radius: 5px;
  background-color: #eee;
  color: #2e7eee;
  padding: 5px 5px;
  cursor: pointer;
}
.que-difficulty{
  width: 10%;
  max-width: 100px;
  display: inline-block;
}
.que_red{
  color: #fff;
  background-color: red;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  height: 26px;
  line-height: 26px;
  padding: 5px 10px
}
.que_white{
  color: #0a001f;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  height: 26px;
  line-height: 26px;
  padding: 5px 10px
}
.que_green{
  color: #fff;
  background-color: green;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  height: 26px;
  line-height: 26px;
  padding: 5px 10px
}
.que_yellow{
  color: #000;
  background-color: yellow;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  height: 26px;
  line-height: 26px;
  padding: 5px 10px
}
.pass_rate{
  width: 10%;
  max-width: 100px;
  display: inline-block;
  border-radius: 5px;
}
.students_count{
  width: 20%;
  max-width: 200px;
  display: inline-block;
}
.que-button{
  width: 10%;
  max-width: 100px;
  display: inline-block;
}

.que-button span{
  display: inline-block;
  border-radius: 5px;
  height: 26px;
  line-height: 26px;
  margin-left: 5px;
  margin-top: 8px;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  border: 1px solid #2e7eee;
  background-color: #2e7eee;
  color: #fff;
}

</style>
